import React from 'react';
import { Link } from 'react-router-dom';

const PageNotFound = () => {
  return (
    <div className='page-not-found'>
      <div className='text-center'>
        <h1>404 Page Not Found</h1>
        <p>Sorry, we couldn't find the page you were looking for.</p>
        <Link to='/' className='btn btn-red'>
          Back Home
        </Link>
      </div>
    </div>
  );
};

export default PageNotFound;
